var _Fragment;
import useCentralizedOrgSlug from "../../../hooks/useCentralizedOrgSlug";
import OrganizationLogoImage from "./components/OrganizationLogoImage";
import useOrganizationTheme from "./hooks/useOrganizationTheme";
import { Fragment as _Fragment2, jsx as _jsx } from "react/jsx-runtime";
var Logo = function Logo(_ref) {
  var organizationSlug = _ref.organizationSlug;
  var _useCentralizedOrgSlu = useCentralizedOrgSlug({
      organizationSlug: organizationSlug
    }),
    centralizedId = _useCentralizedOrgSlu.centralizedId,
    loadingOrganization = _useCentralizedOrgSlu.loading;
  var _useOrganizationTheme = useOrganizationTheme(Number(centralizedId)),
    data = _useOrganizationTheme.data,
    loading = _useOrganizationTheme.loading;
  if (loading || loadingOrganization) return _Fragment || (_Fragment = /*#__PURE__*/_jsx(_Fragment2, {}));
  return /*#__PURE__*/_jsx("div", {
    id: "main-menu-logo",
    className: "tw-hidden sm:tw-flex tw-items-center tw-w-[25.6rem] -tw-ml-[6.3rem] tw-justify-center tw-flex-shrink-0  tw-mr-auto",
    children: /*#__PURE__*/_jsx(OrganizationLogoImage, {
      src: data,
      alt: organizationSlug
    })
  });
};
export default Logo;